// Controlled service-worker update flow.
//
// Extracted from index.js so UI (UpdateBanner) can import `applyUpdate` without
// pulling in the app's render entry point — importing index.js executes
// ReactDOM.createRoot() at module load, which crashes under jsdom (no #root)
// and broke the whole Jest suite. Keeping this here also removes the
// index → App → UpdateBanner → index import cycle.

let waitingWorker = null;

export function applyUpdate() {
  if (waitingWorker) {
    waitingWorker.postMessage({ type: 'SKIP_WAITING' });
  }
}

export function registerServiceWorkerUpdates() {
  if (!('serviceWorker' in navigator)) return;

  if (process.env.NODE_ENV !== 'production') {
    // In dev, CRA serves an unhashed /static/js/bundle.js — any SW that caches
    // it serves stale code after webpack rebuilds. Unregister any leftover SW.
    window.addEventListener('load', () => {
      navigator.serviceWorker.getRegistrations().then(regs => {
        regs.forEach(reg => reg.unregister());
      });
    });
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('SW registered: ', registration);

        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New version is available — notify the app (don't auto-reload)
              waitingWorker = newWorker;
              window.dispatchEvent(new CustomEvent('swUpdateAvailable'));
            }
          });
        });
      })
      .catch(registrationError => {
        console.log('SW registration failed: ', registrationError);
      });
  });

  // When the new SW takes over, reload to use the new version
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}
